import { useState, useContext } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import clsx from 'clsx'
import { Modal } from 'react-bootstrap'
import { ComponentRequest } from '../componentLayout'
import { swlAlert } from '../sweetAlert'
import Swal from 'sweetalert2'
import { approvedCSv } from './api'
const editUserSchema = Yup.object().shape({
    status: Yup.string().required('Status is required'),
    approved_reject_remarks: Yup.string().trim().required('Remarks is required').min(10, 'Remarks must be at least 10 characters'),
    key: Yup.string().test('is-mixed-length-4', 'wrong key', (value) => {
        if (!value) return true; // Allow empty strings
        return /^[0-9a-zA-Z]{4}$/.test(value);
    }).required('Key is required'),
})

/**
 * CsvAprovedFileForm component for approving or rejecting uploaded CSV files.
 * - Renders a modal form for status, verification key, and remarks.
 * - Uses Formik and Yup for form state, validation, and submission.
 * - Handles confirmation dialog and API call for approval/rejection.
 */
const CsvAprovedFileForm = ({ url = null }) => {
    const styles = {
        borderRadius: '0.475rem',
        boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
        backgroundColor: '#fff',
        color: '#7e8299',
        fontWeight: '500',
        margin: '0',
        width: 'auto',
        padding: '1rem 2rem',
        top: 'calc(50% - 2rem)',
        left: 'calc(50% - 4rem)',
    }
    const [loader, setloader] = useState(false)
    const { comRequest } = useContext(ComponentRequest)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            key: '',
            status: '',
            approved_reject_remarks: '',
        },
        validationSchema: editUserSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                const confirmResult = await await Swal.fire({
                    title: 'Are you sure?',
                    text: 'Are you sure you want to add?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    reverseButtons: true,
                    width: '500px',
                    customClass: {
                        confirmButton: 'btn btn-danger',
                        cancelButton: 'btn btn-secondary'
                    }
                });
                if (confirmResult.isConfirmed) {
                    setloader(true)
                    await approvedCSv(values).then((response) => {
                        setloader(false)
                        swlAlert(response, comRequest?.rowLink)
                    })
                } else {
                    // User clicked "Cancel," do nothing or handle as needed
                }
            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        }
    })

    const confirmationPopup = (type) => {
        setIsModalOpen(type)
    }
    return (<>

        <div onClick={() => confirmationPopup(true)} className="symbol symbol-25px cursor-pointer symbol-circle me-2">
            <span className="symbol-label fs-6 fw-semibold text-white bg-dark bg-hover-success bg-hover-success">

                <i className="bi bi-database-fill-add text-white fs-5 fw-semibold"></i>
            </span>
        </div>

        <Modal className={'modal-lg'} show={isModalOpen} onHide={() => setIsModalOpen(false)}>
            <Modal.Header className='h-20px bg-dark text-white' closeButton>  <h4 className="fw-semibold text-white fs-5 py-1"> Approve/Reject CSV file</h4></Modal.Header>
            <Modal.Body className='bg-gray-300'>
                {loader && <div style={{ ...styles, position: 'absolute', textAlign: 'center' }}>
                    <button class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span> Loading...
                    </button>
                </div>}
                <div className='px-5 '>
                    <form id="upload_file"
                        className="form fv-plugins-bootstrap5 fv-plugins-framework"
                        onSubmit={formik.handleSubmit}
                        noValidate>
                        <div className="card-body pt-3">
                            <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed p-6">
                                <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="currentColor"></path>
                                        <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="currentColor"></path>
                                    </svg>
                                </span>
                                <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                                    <div className="mb-3 mb-md-0 fw-semibold">
                                        <h5 className="text-gray-900 fw-semibold">Key Verification</h5>
                                        <div className="fs-7 text-gray-700 pe-7">
                                            Two-factor authentication adds an extra layer of security to your account. To log in,
                                            in addition you'll need to provide 4 digit code
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <label className="col-lg-4 col-form-label required fw-semibold fs-6">CSV Status</label>
                                    <div className="row">
                                        <div className="col-lg-12 fv-row">
                                            <div className="form-check form-check-inline">
                                                <input
                                                    {...formik.getFieldProps('status')}
                                                    type='radio'
                                                    onChange={() => { formik.setFieldValue('status', 1) }}
                                                    name='status'
                                                    id={'inlineenabled'}
                                                    className={clsx(
                                                        'form-check-input',

                                                    )}
                                                    autoComplete='off'
                                                    value={1}
                                                    checked={formik.values.status === 1}

                                                />
                                                <label className="form-check-label" for="inlineenabled">
                                                    <span className="form-check-label ms-0 fw-semibold fs-6 text-gray-700">Approved</span>
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    {...formik.getFieldProps('status')}
                                                    type='radio'
                                                    onChange={() => { formik.setFieldValue('status', 2) }}
                                                    id={'inlinedisabled'}
                                                    name='status'
                                                    className={clsx(
                                                        'form-check-input',
                                                    )}
                                                    autoComplete='off'
                                                    value={2}
                                                    checked={formik.values.status === 2}

                                                />
                                                <label className="form-check-label" for="inlinedisabled">
                                                    <span className="form-check-label ms-0 fw-semibold fs-6 text-gray-700">Rejected</span>
                                                </label>
                                            </div>
                                            {formik.touched.status && formik.errors.status ? (
                                                <div className='fv-plugins-message-container'>
                                                    <div className='fv-help-block'>
                                                        <span className='text-danger' role='alert'>{formik.errors.status}</span>
                                                    </div>
                                                </div>
                                            ) : <div className="text-muted fs-7"></div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="row">
                                        <label className="col-lg-4 col-form-label required fw-semibold fs-6">Enter Verification Key</label>
                                        <div className="col-lg-12 fv-row">

                                            <input
                                                placeholder="Enter Key"
                                                {...formik.getFieldProps('key')}
                                                type='text'
                                                onChange={formik.handleChange}
                                                name='key'
                                                className={clsx(
                                                    'form-control form-control-md rounded-0 mb-lg-0 mb-3',
                                                    { 'is-invalid': formik.touched.key && formik.errors.key },
                                                    { 'is-valid': formik.touched.key && !formik.errors.key, }
                                                )}
                                                autoComplete='off'

                                            />
                                            {formik.touched.key && formik.errors.key ? (
                                                <div className='fv-plugins-message-container'>
                                                    <div className='fv-help-block'>
                                                        <span className='text-danger' role='alert'>{formik.errors.key}</span>
                                                    </div>
                                                </div>
                                            ) : <div className="text-muted fs-7"></div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="row">
                                        <label className="col-lg-4 col-form-label required fw-semibold fs-6">Remarks</label>
                                        <div className="col-lg-12 fv-row">
                                            <textarea
                                                name="approved_reject_remarks"
                                                className={clsx(
                                                    'form-control form-control-md rounded-0 mb-lg-0 mb-3',
                                                    { 'is-invalid': formik.touched.approved_reject_remarks && formik.errors.approved_reject_remarks },
                                                    { 'is-valid': formik.touched.approved_reject_remarks && !formik.errors.approved_reject_remarks, }
                                                )}
                                                placeholder="Type Remarks"
                                                onChange={formik.handleChange}
                                            >
                                            </textarea>
                                            {formik.touched.approved_reject_remarks && formik.errors.approved_reject_remarks ? (
                                                <div className='fv-plugins-message-container'>
                                                    <div className='fv-help-block'>
                                                        <span className='text-danger' role='alert'>{formik.errors.approved_reject_remarks}</span>
                                                    </div>
                                                </div>
                                            ) : <div className="text-muted fs-7"></div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*end::Card body*/}
                        <div className='card-footer py-2'>
                            <div className="d-flex justify-content-end">
                                {/*begin::Button*/}

                                <button type="submit" className="btn btn-primary"
                                    disabled={loader}>
                                    <span className="indicator-label">{formik?.values?.id ? "Submit" : "Submit"}</span>
                                    {(formik.isSubmitting) && <span className="indicator-progress">Please wait...
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>}
                                </button>
                                {/*end::Button*/}
                            </div>
                        </div>
                    </form>
                </div>


            </Modal.Body>

        </Modal>
    </>
    )
}

export default CsvAprovedFileForm